import type { ReactNode } from 'react';
import React from 'react';

import { FlagsProvider } from '@atlaskit/flag/flags-provider';

import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

import { toUsableIdentityAccountId } from './toUsableIdentityAccountId.ts';

export type ProfileIdentityProps = {
	userId?: string | null;
	fullName?: string;
	children: ReactNode;
	agent?: Record<string, never>;
	trigger?: 'click' | 'hover';
	position?: 'bottom-start' | 'left-start';
	offset?: [number, number];
};

export const ProfileIdentity = ({
	userId,
	fullName,
	children,
	agent,
	trigger = 'click',
	position = 'bottom-start',
	offset = [0, 8],
}: ProfileIdentityProps): React.JSX.Element => {
	const usableUserId = toUsableIdentityAccountId(userId);
	if (!usableUserId) {
		return <>{children}</>;
	}

	const card = (
		<ProfileCardWrapper
			userId={usableUserId}
			fullName={fullName}
			trigger={trigger}
			position={position}
			offset={offset}
			{...(agent ? { agent } : {})}
		>
			{children}
		</ProfileCardWrapper>
	);

	if (agent) {
		return <FlagsProvider>{card}</FlagsProvider>;
	}

	return card;
};
